<template>
    <v-flex class="presentation d-flex justify-space-between align-center">
        <a href="https://v2.lasolutionarchibald.com" target="_blank" style="margin-left: 3em;">
            <img src="../../assets/images/archibald_orange_small.png" alt="" style="height: 3em;">
        </a>
        <h1>
            {{ getCollectivite() }}Simulateur{{ getGeneric() }} de taxe sur la publicité extérieure (TLPE)
        </h1>
        <a href="https://www.gopubconseil.fr" target="_blank" style="margin-right: 3em;">
            <img src="../../assets/images/logo-complet-couleur.png" alt="" style="height: 3em;">
        </a>
    </v-flex>
</template>

<script>
import { mapState } from 'vuex';
import { getCollectivityName } from '../../utils'
export default {
    name: 'Presentation',
    components: {},
    mixins: [],
    props: {},
    data() {
        return {};
    },
    computed: {
        ...mapState('collectivite', ['collectivite']),
    },
    watch: {},
    created() {

    },
    methods: {
        getGeneric(){
            if('simulateur-generique' === this.$route.name){
                return ' générique';
            }

            return '';
        },
        getCollectivite() {
            if('simulateur-collectivite' === this.$route.name && this.$route.params.collectivite){
                return ` ${getCollectivityName(this.collectivite)} : `;
            }

            return '';
        },
    },
}
</script>

<style scoped>
.presentation {
    position: fixed;
    width: 100%;
    height: 5em;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.05), 0 0 3px 0 rgba(0, 0, 0, 0.05);
    background-color: white;
    top: 0;
    left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Simulateur/Presentation.vue